import { useHistory } from "react-router";
import { useTranslate } from "../contexts/translate";
import styled from "styled-components";
import { categories } from "../pages/Cards";
import { Subheader } from "./ui/Subheader";
import { useNavigate } from "react-router-dom";

export type CategoryType =
  | "swas"
  | "troops"
  | "terrains"
  | "actions"
  | "nations";

function getIconFilename(icon: string) {
  if (icon.startsWith("swas")) {
    return "SWas.png";
  }
  if (icon.startsWith("troop")) {
    return "Troop.png";
  }
  if (icon.startsWith("terrain")) {
    return "Terrain.png";
  }
  if (icon.startsWith("action")) {
    return "Action.png";
  }
  if (icon.startsWith("nation")) {
    return "Nation.png";
  }
}

const Icon = styled.span<{ icon: string }>`
  display: block;
  height: 100%;
  aspect-ratio: 1;
  background: url("/assets/ui/cards/${({ icon }) => getIconFilename(icon)}");
  background-size: contain;
  background-repeat: no-repeat;
`;

const Arrow = styled.button<{ dir: "left" | "right" }>`
  width: calc(0.5 * 50 * var(--u) * 259 / 1512);
  height: calc(0.5 * 50 * var(--u) * 259 / 1512);
  background: url("/assets/ui/Nav-Arrow ${({ dir }) => dir}.png");
  background-size: contain;
  background-repeat: no-repeat;

  &[disabled] {
    opacity: 0.5;
  }
`;

const Title = styled.div`
  width: calc(50 * var(--u));
  height: calc(50 * var(--u) * 259 / 1512);
  display: flex;
  flex-direction: row;
  align-items: center;

  span.label {
    display: block;
    flex-grow: 1;
    text-align: center;
    color: black;
    font-size: calc(4 * var(--u));
  }
`;

export function CategorySubheader(props: { category: CategoryType }) {
  const { translate } = useTranslate();
  const navigate = useNavigate();

  function prev() {
    const index = categories.indexOf(props.category);
    if (index === 0) {
      navigate(`/cards/${categories[categories.length - 1]}`, {
        replace: true,
      });
    } else {
      navigate(`/cards/${categories[index - 1]}`, { replace: true });
    }
  }

  function next() {
    const index = categories.indexOf(props.category);
    if (index === categories.length - 1) {
      navigate(`/cards/${categories[0]}`, { replace: true });
    } else {
      navigate(`/cards/${categories[index + 1]}`, { replace: true });
    }
  }

  return (
    <>
      <Subheader>
        <Arrow dir="left" onClick={() => prev()} />
        <Title>
          {props.category && <Icon icon={props.category} />}
          <span className="label">
            {translate(`components.CategorySubheader.${props.category}`)}
          </span>
        </Title>
        <Arrow dir="right" onClick={() => next()} />
      </Subheader>
    </>
  );
}
